const b = [];
function p() {
  const o = {}, i = {}, d = (n, e) => {
    const r = "before" in e ? e.before : void 0, t = "after" in e ? e.after : void 0;
    if (r) {
      const s = n.findIndex((c) => r.includes(c.key));
      if (s !== -1)
        return s;
    }
    if (t) {
      const s = n.findIndex((c) => t.includes(c.key));
      if (s !== -1)
        return s + 1;
    }
    return n.length;
  }, f = (n, e) => {
    const r = d(n, e);
    return [...n.slice(0, r), e, ...n.slice(r)];
  }, l = (n, e) => {
    const r = "before" in n ? n.before : void 0, t = "after" in n ? n.after : void 0;
    return r?.includes(e) === !0 || t?.includes(e) === !0;
  }, a = (n, e) => n.reduce((r, t) => {
    if (t.key === e || !l(t, e))
      return r;
    const s = r.filter((c) => c !== t);
    return f(s, t);
  }, n), x = (n, e) => {
    const r = o[n], t = r.indexOf(e);
    t !== -1 && (r.splice(t, 1), u(n));
  }, u = (n) => {
    i[n]?.forEach((e) => e());
  };
  return {
    getItems(n) {
      return o[n] ?? b;
    },
    subscribe(n, e) {
      const r = i[n] ??= /* @__PURE__ */ new Set();
      return r.add(e), () => r.delete(e);
    },
    register(n, e) {
      const r = o[n];
      return r ? o[n] = a(f(r, e), e.key) : o[n] = [e], u(n), () => x(n, e);
    }
  };
}
export {
  p as createApplicationMenu
};
